// Prenatal page (.tp-pp) — guarded so it only runs on page-prenatal.php.
// FAQ accordion (single-open) + smooth in-page anchors. The mobile burger is
// handled by default-page.js (shared .tp-default header).
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-pp');
    if (!root) {
        return;
    }

    // ── FAQ accordion (single-open: opening one closes the others) ──
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.pp-faq-item'));

    function setFaq(item, open) {
        var panel = item.querySelector('.pp-faq-panel');
        var sign = item.querySelector('.pp-faq-sign');
        item.classList.toggle('is-open', open);
        var q = item.querySelector('button'); if (q) { q.setAttribute('aria-expanded', open ? 'true' : 'false'); }
        if (panel) {
            panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        }
        if (sign) {
            sign.textContent = open ? '–' : '+';
        }
    }

    faqItems.forEach(function (item) {
        var btn = item.querySelector('.pp-faq-q');
        if (!btn) {
            return;
        }
        if (item.classList.contains('is-open')) {
            setFaq(item, true);
        }
        btn.addEventListener('click', function () {
            var willOpen = !item.classList.contains('is-open');
            faqItems.forEach(function (other) {
                if (other !== item) {
                    setFaq(other, false);
                }
            });
            setFaq(item, willOpen);
        });
    });

    // ── Smooth scroll for in-page anchors ──
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
            var hash = link.getAttribute('href');
            if (hash.length < 2) {
                return;
            }
            var target = document.querySelector(hash);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            document.body.classList.remove('menu-open');
        });
    });
});
